/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import axios from "axios/index";
import * as types from "./types";
import returnUrlParams from "@/http/returnUrlParams";

const actions = {
  [types.GET_MODERATION_CHECK](context, { locale, text }) {

    const requestUrl = `${this.state.endPoints.customizer.filterText}`;
    
    const requestParams = {text};
    if (locale) requestParams.locale = locale;

    const data = returnUrlParams(requestParams);

    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: data
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  }
};

export default actions;
